import { Injectable } from '@angular/core';
import { Transaction } from '../model/transaction.model';

@Injectable({
  providedIn: 'root'
})
export class RelationsService {

  constructor() { }

  concatRelations(element: Transaction, style: string) {
    let relations = '';
    const formatting = style === 'comma' ? ', ' : '<br>';

    if (element.isTenPercentOwner === '1') {
      relations = relations.concat('10% owner' + formatting);
    }
    if (element.isDirector === '1') {
      relations = relations.concat('Director' + formatting);
    }
    if (element.officerTitle && element.officerTitle !== '') {
      relations = relations.concat(element.officerTitle);
    }
    if (relations[relations.length - 2] === ',') {
      relations = relations.slice(0, relations.length - 2);
    }
    return relations;
  }
}
